import { render, staticRenderFns } from "./upload-pic-thumb.vue?vue&type=template&id=6d9a3ecc&"
import script from "./upload-pic-thumb.vue?vue&type=script&lang=js&"
export * from "./upload-pic-thumb.vue?vue&type=script&lang=js&"
import style0 from "./upload-pic-thumb.vue?vue&type=style&index=0&id=6d9a3ecc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports